import React from 'react';
import { Paperclip, Download, Calendar, FileText, User, FolderOpen } from 'lucide-react';

const AttachmentsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  const getFileIcon = (fileType) => {
    return <FileText className="w-6 h-6 text-white" strokeWidth={2.5} />;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#6366F1] to-[#818CF8] rounded-xl flex items-center justify-center">
          <Paperclip className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">المرفقات والمستندات</h2>
      </div>

      {caseData.attachments && caseData.attachments.length > 0 ? (
        <div className="space-y-4">
          {caseData.attachments.map((attachment) => (
            <div 
              key={attachment.id}
              className="border-2 border-gray-200 rounded-xl p-5 hover:border-[#6366F1] transition-all hover:shadow-lg bg-white flex items-center justify-between"
            >
              <div className="flex items-center gap-4 flex-1">
                <div className="w-12 h-12 bg-gradient-to-br from-[#6366F1] to-[#818CF8] rounded-lg flex items-center justify-center flex-shrink-0">
                  {getFileIcon(attachment.fileType)}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-black text-gray-900 truncate">{attachment.fileName}</h3>
                  <div className="flex items-center gap-3 mt-1 text-sm text-gray-600">
                    <span className="px-2 py-0.5 bg-indigo-100 text-indigo-800 rounded text-xs font-bold">
                      {attachment.fileType}
                    </span>
                    <span className="font-semibold">{attachment.fileSize}</span>
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-700 rounded text-xs font-semibold">
                      {attachment.category}
                    </span>
                  </div>
                  {attachment.description && (
                    <p className="text-sm text-gray-600 mt-2">{attachment.description}</p>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-4 flex-shrink-0">
                <div className="text-right">
                  <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
                    <Calendar className="w-3.5 h-3.5" />
                    <span>{attachment.uploadDate}</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-500">
                    <User className="w-3.5 h-3.5" />
                    <span>{attachment.uploadedBy}</span>
                  </div>
                </div>
                {attachment.canDownload && (
                  <button className="px-4 py-2 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors flex items-center gap-2 font-bold">
                    <Download className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <FolderOpen className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد مرفقات</p>
        </div>
      )}
    </div>
  );
};

export default AttachmentsSection;